import { axiosJSONInstance } from '@/config';
import { RegionResponse } from '@/types/region';

/**
 * The province reference list.
 *
 * `scope: 'pickup'` narrows it to provinces Boxy actually COLLECTS from —
 * activated branches plus Baghdad. Only the pickup-origin forms may ask for
 * that; every other picker on this endpoint is choosing a DESTINATION or a rule
 * condition and needs the full list.
 *
 * 🔴 The backend default deliberately stays unfiltered. It was briefly changed
 * to return the pickup list to everyone, which left merchants able to address a
 * customer in Baghdad or Anbar and nowhere else — one endpoint answers both
 * "where may I ship from" and "where may I ship to", and only the caller knows
 * which it is asking.
 */
export const fetchListProvinces = async (scope?: 'pickup'): Promise<RegionResponse> => {
  const response = await axiosJSONInstance.get(`/merchants/regions/provinces`, {
    params: scope ? { for: scope } : undefined,
  });
  return response.data;
};

// Fetch area for a province By Code
export const fetchAreaByProvinceCode = async (ProvinceCode: string): Promise<RegionResponse> => {
  const response = await axiosJSONInstance.get(`/merchants/regions/provinces/${ProvinceCode}`);
  return response.data;
};
